import {BaseFormModel} from './base-form-model';
import {MenuSelectionItem} from './menu-selection-item';
import {OrderItem} from './order-item';
import {addCurrency, multiplyCurrency} from '../_utils/currency-math';
import {convertPercentage} from '../_utils/tax-utils';

export class OrderItemSelectionItem extends BaseFormModel<OrderItemSelectionItem> {
    id: number;
    additionalPrice: number;
    selectionCountPrice: number;
    menuSelectionItem: MenuSelectionItem;
    orderItem: OrderItem;
    parentAmount: number;

    public constructor(jsonInput: any) {
        super(jsonInput);
        Object.assign(this, jsonInput);
        this.orderItem = new OrderItem(this.orderItem);
        this.orderItem.init();
    }

    total(parentAmount: number) {
        let percentageOfParent = null;

        if (!!this.orderItem.selectedPrice) {
            percentageOfParent = this.orderItem.selectedPrice.percentageOfParent ? this.orderItem.selectedPrice.price : null;
        } else {
            percentageOfParent = this.orderItem.menuItem.percentageOfParent();
        }

        if (this.orderItem.menuItem.isVariable()) {
            return this.orderItem.priceOverride;
        } else if (!!percentageOfParent) {
            return multiplyCurrency(parentAmount, convertPercentage(percentageOfParent));
        } else {
            const price = this.menuSelectionItem.priceFromItem
                ? this.menuSelectionItem.menuItemPrice.price : this.menuSelectionItem.additionalPrice;

            let selectionTotal = (!!this.menuSelectionItem && !!price
                ? price
                : 0);

            if (!!this.orderItem && !!this.orderItem.selections && this.orderItem.selections.length > 0) {
                selectionTotal = addCurrency(selectionTotal,
                    this.orderItem.selections.reduce((tot, selection) => addCurrency(tot, selection.calculateTotal(!!parentAmount
                        ? parentAmount
                        : 0)), 0));
            }

            if (!!this.orderItem && !!this.orderItem.modifiers) {
                this.orderItem.modifiers.forEach(m => {
                    selectionTotal = addCurrency(selectionTotal, m.additionalPrice);
                });
            }

            return addCurrency((!!this.orderItem && !!this.orderItem.optionalToppings
                    ? this.orderItem.addedToppingsFilter()
                        .reduce((tot, topping) => addCurrency(tot, topping.additionalPrice), 0) : 0),
                selectionTotal);
        }
    }

    depositTotal() {
        return this.orderItem.menuItem.deposit();
    }
}
